import { render, staticRenderFns } from "./ShippingCostTable.vue?vue&type=template&id=f421b3dc&scoped=true"
import script from "./ShippingCostTable.vue?vue&type=script&lang=js"
export * from "./ShippingCostTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f421b3dc",
  null
  
)

export default component.exports